import { useEffect, useState } from 'react';
import axios from 'axios';
import { CONFIG } from 'variables/config';
import { FaCheckCircle } from 'react-icons/fa';
import PurchaseOrderSuccessModal from './components/PurchaseOrderSuccessModal';

const PaiementSuccess = () => {
    const [kycVerified, setKycVerified] = useState(true);
    const paymentType = new URLSearchParams(window.location.search).get('type');
    const isPurchaseOrder = paymentType === 'purchase-order';
    const isWalletTopup = paymentType === 'wallet-topup';
    const [isPurchaseOrderModalOpen, setIsPurchaseOrderModalOpen] = useState(isPurchaseOrder);
    const initUser = () => {
        const token = localStorage.getItem('token');
        const config = {
            headers: { Authorization: `Bearer ${token}` },
        };
        axios
            .get(`${CONFIG.apiUrl}/user/me`, config)
            .then((res) => {
                const user = res.data;
                if (user.kyc_url) {
                    setKycVerified(false);
                    setTimeout(() => {
                        window.location.href = user.kyc_url;
                    }, 3000);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        initUser();
    }, []);

    return (
        <main className="flex min-h-[70vh] items-center justify-center px-4">
            <div className="w-full max-w-md rounded-xl border border-leadrs-stroke bg-white p-8 text-center shadow-sm">
                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-leadrs-green-soft">
                    <FaCheckCircle className="text-2xl text-leadrs-green-focus" />
                </div>
                <h1 className="mb-2 font-crimson text-2xl font-semibold text-leadrs-text">
                    Paiement réussi !
                </h1>
                <p className="mb-6 font-geist text-sm text-leadrs-text-soft">
                    {isWalletTopup
                        ? 'Votre cagnotte a été rechargée avec succès.'
                        : 'Merci pour votre commande.'}
                </p>
                {kycVerified ? (
                    <a
                        href={isWalletTopup ? '/admin/wallet' : '/dashboard'}
                        className="inline-block rounded-lg bg-leadrs-green-focus px-5 py-2.5 font-geist text-sm font-medium text-white transition-opacity hover:opacity-80"
                    >
                        {isWalletTopup ? 'Voir mon portefeuille' : 'Voir mes commandes'}
                    </a>
                ) : (
                    <p className="font-geist text-sm text-leadrs-text-soft">
                        Vous allez être redirigé vers la page de vérification
                        KYC dans quelques secondes.
                    </p>
                )}
            </div>
            <PurchaseOrderSuccessModal
                isOpen={isPurchaseOrderModalOpen}
                onClose={() => setIsPurchaseOrderModalOpen(false)}
            />
        </main>
    );
};

export default PaiementSuccess;
